import { render, staticRenderFns } from "./ConsolidationOrdersTable.vue?vue&type=template&id=406a8d52&scoped=true"
import script from "./ConsolidationOrdersTable.vue?vue&type=script&lang=js"
export * from "./ConsolidationOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a8d52",
  null
  
)

export default component.exports